export default "__VITE_ASSET__CDK3Sk0E__"